import { render, staticRenderFns } from "./ModalDesfazerLiberacao.vue?vue&type=template&id=36ae1c25"
import script from "./ModalDesfazerLiberacao.vue?vue&type=script&lang=ts"
export * from "./ModalDesfazerLiberacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports